import React from 'react';
import { getFullVersionString, getCopyrightString } from '../../config/version';

interface VersionInfoProps {
  variant?: 'login' | 'footer';
}

export const VersionInfo: React.FC<VersionInfoProps> = ({ variant = 'login' }) => {
  if (variant === 'login') {
    return (
      <div style={styles.loginVersion}>
        {getFullVersionString()}
      </div>
    );
  }

  return (
    <div style={styles.footerVersion}>
      {getCopyrightString()}
    </div>
  );
};

export const AppFooter: React.FC = () => {
  return (
    <footer style={styles.footer}>
      <VersionInfo variant="footer" />
    </footer>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  loginVersion: {
    textAlign: 'center',
    fontSize: '0.75rem',
    color: '#888',
    marginTop: '1rem',
  },
  footerVersion: {
    textAlign: 'center',
    fontSize: '0.75rem',
    color: '#888',
  },
  footer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#f5f5f5',
    borderTop: '1px solid #e0e0e0',
    padding: '0.5rem 1rem',
    zIndex: 100,
  },
};

export default AppFooter;
